import {
  ArrowUpRight,
  CalendarTime,
  CreditCard,
  LocationMarker,
  User1,
  Vaccine,
} from "@repo/icons";

const TERMS_AND_CONDITIONS_URL =
  "https://ajuda.livance.com.br/hc/pt-br/articles/28453177206547-Condi%C3%A7%C3%B5es-Gerais-para-a-Loca%C3%A7%C3%A3o-e-Presta%C3%A7%C3%A3o-de-Servi%C3%A7os";

export const GeneralTermsChangeList = (): JSX.Element => {
  return (
    <ul className="flex flex-col items-start gap-6 text-sm font-normal text-neutral-600">
      <li className="flex text-start gap-2">
        <span className="p-2 bg-primary-50 rounded-full max-h-[42px] max-w-[42px]">
          <User1 className="fill-primary-400" size={24} />
        </span>
        <span>Incluímos a criação do Acesso de Assistente.</span>
      </li>
      <li className="flex text-start gap-2">
        <span className="p-2 bg-primary-50 rounded-full max-h-[42px] max-w-[42px]">
          <CreditCard className="fill-primary-400" size={24} />
        </span>
        <span>
          Adicionamos informações sobre taxa de uso das máquinas de cartão e serviços
          adicionais de pagamento.
        </span>
      </li>
      <li className="flex text-start gap-2">
        <span className="p-2 bg-primary-50 rounded-full max-h-[42px] max-w-[42px]">
          <LocationMarker className="fill-primary-400" size={24} />
        </span>
        <span>Incluímos a Política de Uso de Estacionamento.</span>
      </li>
      <li className="flex text-start gap-2">
        <span className="p-2 bg-primary-50 rounded-full max-h-[42px] max-w-[42px]">
          <CalendarTime className="fill-primary-400" size={24} />
        </span>
        <span>
          Atualizamos a cláusula relacionada ao serviço de agendamento de consultas,
          refletindo a evolução do serviço.
        </span>
      </li>
      <li className="flex text-start gap-2">
        <span className="p-2 bg-primary-50 rounded-full max-h-[42px] max-w-[42px]">
          <Vaccine className="fill-primary-400" size={24} />
        </span>
        <span>
          Destacamos a responsabilidade do profissional pelos procedimentos, conforme o
          Guia de Práticas.
        </span>
      </li>
      <a
        className="inline-flex items-center gap-2 text-secondary-300 cursor-pointer"
        href={TERMS_AND_CONDITIONS_URL}
        target="_blank"
        rel="noopener"
      >
        <span className="text-sm font-medium">
          Clique aqui para ler o contrato na íntegra
        </span>
        <ArrowUpRight className="fill-secondary-300" size={16} />
      </a>
    </ul>
  );
};
